import { React, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import './hero.css';
import PillHollow from '../pill-hollow/PillHollow';
import CTAButton from '../cta-button/CTAButton';
import CPUNodes1 from '../elements-icons/CPUNodes1';
import RightArrowCircular from '../elements-icons/RightArrowCircular';

const Hero = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Try to get the element by ID
      let element = document.getElementById(location.hash.substring(1));
      
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If there's no hash, scroll to the top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]); // Re-run the effect whenever the location changes
  
  return (
    <section className='section-hero'>
      <div className='wrapper-hero'>
        <PillHollow icon={<CPUNodes1 svgClass='icon-lg' pathClass='icon-wht'/>} content='Skill Up With Prompt AI University!' />
        <h1 className='title-main'>
        Future-Proofing<br/>
        Today's Professionals
        </h1>
        <p className='content-hero'>
          At Prompt AI University, our mission is simple: to 'Teach valuable AI prompting skills in a way that is accessible to everyone'. Step into the future of communication and innovation. Embrace the power of prompt engineering.
        </p>
        <CTAButton url='/#what-is-it' icon={<RightArrowCircular svgClass='icon-md' pathClass='icon-wht'/>} className='btn-cta-sub bg-straight-gradient-purple text-lt' content='Get Started'/>
      </div>
    </section>
  );
}

export default Hero;